import { FC } from 'react';
// @ts-ignore
import qs from 'query-string';
import BootstrapDropdown from 'react-bootstrap/Dropdown';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import cn from '../../utils/classnames';
import './dropdown.scss';

export type DropdownOption = {
    id: number | string;
    title: string;
    active?: boolean;
    'data-testid'?: string;
};

export type DropdownProps = RouteComponentProps & {
    className: string;
    disabled: boolean;
    label: string;
    onSelect: (arg: DropdownOption) => void;
    options: DropdownOption[];
    onBeforeHistoryPush: (arg?: DropdownOption) => boolean;
    selectedValue: DropdownOption;
    withQuery: boolean;
};

const Dropdown: FC<DropdownProps> = ({
    label,
    className,
    selectedValue,
    options,
    onSelect = (arg?: DropdownOption) => {}, // eslint-disable-line no-unused-vars
    onBeforeHistoryPush = (arg?: DropdownOption) => true,
    withQuery = false,
    ...rest
}) => {
    const handleClick = (selectedOption: DropdownOption) => {
        if (!withQuery) {
            // @ts-ignore
            onSelect(selectedOption);
        } else {
            const search = qs.parse(rest.location.search, { arrayFormat: 'comma' });

            onBeforeHistoryPush(selectedOption);

            rest.history.push(
                `${rest.location.pathname}?${qs.stringify(
                    {
                        ...search,
                        query: search.query || '',
                        s: selectedOption.id
                    },
                    { arrayFormat: 'comma' }
                )}`
            );
        }
    };

    return (
        <div className={cn('lmp-dropdown d-flex align-items-center', className)}>
            {label && <span className='dropdown-title'>{label}</span>}
            <BootstrapDropdown className='custom-dropdown ms-12'>
                <BootstrapDropdown.Toggle
                    disabled={rest.disabled}
                    id='dropdown-lmp'
                    variant='default'
                    data-testid='search-dropdown-toggle'
                >
                    <span>{selectedValue.title}</span>
                </BootstrapDropdown.Toggle>
                <BootstrapDropdown.Menu>
                    {options.map((option: DropdownOption) => (
                        <BootstrapDropdown.Item
                            key={option.id}
                            active={option.active}
                            onClick={() => handleClick(option)}
                            {...option}
                        >
                            {option.title}
                        </BootstrapDropdown.Item>
                    ))}
                </BootstrapDropdown.Menu>
            </BootstrapDropdown>
        </div>
    );
};

export default withRouter(Dropdown);
